import { URLSearchParams } from '@angular/http';
import { Output } from '@angular/core';

export class DataSource {
  private parent: any;
  private service: any;
  private resultKey: string;
  private querystrings: any;
  private query: URLSearchParams;
  @Output() errorMessage;

  public rowCount: any;
  private beforeRequest;
  private successCallback;

  constructor(params: any) {
    this.parent = params.parent;
    this.service = params.service;
    this.resultKey = params.resultKey;
    this.querystrings = params.querystrings;
    this.beforeRequest = params.beforeRequest;
    this.successCallback = params.successCallback;
  }

  setQuery(query) {
    this.query = query;
  }

  getRows(params) {
    this.parent.working = true;

    // ヘッダーのオーナーを変更出来ないようにする。
    if(this.parent.headerComponent) {
      this.parent.headerComponent.ownerSelect = true;
    }

    // If the query is undefined create a new one
    if (!this.query) {
      this.query = new URLSearchParams();
    }
    // Set the pagination parameters
    this.query.set('startRow', params.startRow);
    this.query.set('endRow', params.endRow);
    // Set the ordering parameters if any
    if (params.sortModel.length > 0) {
      const colId = params.sortModel[0].colId;
      const sort = params.sortModel[0].sort;
      this.query.set('colId', colId);
      this.query.set('sort', sort);
    }

    if (this.querystrings) {
      for (var i in this.querystrings) {
        this.query.set(i, this.querystrings[i]);
      }
    }

    // Set the filtering options if any
    if (Object.keys(params.filterModel).length > 0) {
      this.query.set('filterModel', JSON.stringify(params.filterModel));
    } else {
      this.query.delete('filterModel');
    }
    if (this.beforeRequest) {
      this.beforeRequest(params)
    }
    console.log('[DataSource::getRows] params of getRows', params, this.query);
    this.service
      .get(this.query)
      .then(outputJson => {
        console.log('[DataSource::getRows::then] Response', outputJson);
        this.parent.working = false;

        // ヘッダーのオーナーを変更できるようにする。
        if(this.parent.headerComponent) {
          this.parent.headerComponent.ownerSelect = false;
        }

        const rowsThisPage = outputJson[this.resultKey];
        const lastRow = outputJson.total;
        // call the success callback
        params.successCallback(rowsThisPage, lastRow);
        if (this.successCallback) {
          this.successCallback(rowsThisPage, lastRow)
        }
      })
      .catch(error => {
        this.parent.working = false;

        // ヘッダーのオーナーを変更できるようにする。
        if (this.parent.headerComponent) {
          this.parent.headerComponent.ownerSelect = false;
        }

        console.log(this.parent.commonService.getErrorMessage(error));
        // this.parent.dialogsService.info('エラー', this.parent.commonService.getErrorMessage(error));
        this.errorMessage = this.parent.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/classes/dataSource/dataSource.ts